import { finalize } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { TelefonosService } from './../../../../services/telefonos.service';
import { TelefonoUltimaTransmision } from './../../../../../../_entities/telefonos/telefono';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'kt-telefono-ultima-transmision',
	templateUrl: './telefono-ultima-transmision.component.html',
	styleUrls: ['./telefono-ultima-transmision.component.scss']
})
export class TelefonoUltimaTransmisionComponent implements OnInit {
	public telefonos: TelefonoUltimaTransmision[];
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public loadingVisible: boolean = false;
	public datosReporte = [];
	 isDisabled: boolean = true;

	constructor(private telefonosService: TelefonosService,
		private mapaService: MapaService,
		private datepipe: DatePipe,
		public dialogRef: MatDialogRef<TelefonoUltimaTransmisionComponent>) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.obtenerTelefonosUltimaTransmision();
	}

	obtenerTelefonosUltimaTransmision() {
		this.loadingVisible = true;
		this.telefonosService.obtenerUltimaTransmisionTelefonos().pipe(
			finalize(() => this.loadingVisible = false)
		).subscribe(
			(telefonos: TelefonoUltimaTransmision[]) => {
				telefonos.map(telefono => {

					if (telefono.bateria) {
						telefono.bateria = telefono.bateria + '%';
					} else {
						telefono.bateria = 'Sin Datos';
					}

					switch (telefono.estatus) {
						case 0:
							telefono.estatus = 'Inactivo';
							break;
						case 1:
							telefono.estatus = 'Activo';
							break;
						default:
							break;
					}
				});
				this.telefonos = telefonos;

				this.telefonos.forEach(telefono => {
					this.datosReporte.push({
						'Batería': telefono.bateria,
						'Económico': telefono.economico,
						'Número de Serie': telefono.numeroSerie,
						'Estatus': telefono.estatus,
						'Descripción': telefono.descripcion,
						'Modelo': telefono.modelo,
						'Fecha y Hora': this.datepipe.transform(telefono.fechaHora, 'dd/MM/yyyy h:mm a'),
						'IMEI': telefono.imei.toString()
					});
				});
				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}
			}
		)
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	ubicarPuntoHistorico(data) {
		this.dialogRef.close();
		this.mapaService.verTelefono(data);
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
